import firebase from "firebase";

var firebaseApp = firebase.initializeApp({
  // Your firebase credentials
  apiKey: "AIzaSyCu-xnh-i9FrQJaGXutOnPoSYeKt1hfnUw",
  authDomain: "amandeepsingh-23.firebaseapp.com",
  projectId: "amandeepsingh-23",
  storageBucket: "amandeepsingh-23.appspot.com",
  messagingSenderId: "532827638858",
  appId: "1:532827638858:web:b8707c04c34379f6ce6ab3",
  measurementId: "G-19Z2TEVYW8"
});

var db = firebaseApp.firestore();

export { db };